/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosRequestConfig, Method, AxiosPromise } from "axios";
import { executeRequest } from "_foundation/axios/axiosConfig";
import { getSite } from "_foundation/hooks/useSite";

const siteContentServiceExt = {
  findKeywordSuggestions(parameters: any, url?: string): AxiosPromise<any> {
    const param = parameters;

    const site = getSite();
    let siteContext = "";
    if (site) {
      siteContext = site.searchContext || "";
    }
    const domain = url || siteContext;
    const path = "/store/{storeId}/sitecontent/keywordSuggestionsByTerm/{term}";
    let requestUrl = domain + path;
    const method: Method = "GET";
    const body = {};
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json; charset=utf-8",
    };
    const queryParameters = new URLSearchParams();

    if (param.storeId === undefined && site !== null) {
      param.storeId = site.storeID;
    }

    if (param.storeId === undefined) {
      throw new Error(
        "Request '/store/{storeId}/sitecontent/suggestions' missing path parameter storeId"
      );
    }
    requestUrl = requestUrl.replace("{storeId}", parameters.storeId);

    if (param.term === undefined) {
      throw new Error(
        "Request '/store/{storeId}/productview/bySearchTerm/{term}' missing required parameter searchTerm"
      );
    }
    requestUrl = requestUrl.replace("{term}", param.term);

    queryParameters.sort();
    const requestOptions: AxiosRequestConfig = {
      params: queryParameters,
      method,
      headers: header,
      data: body,
      url: requestUrl,
      ...parameters,
    };
    return executeRequest(requestOptions);
  },
};

export default siteContentServiceExt;
